
const FatalFourSection = () => {
  return (
    <section className="py-16 bg-white">
      <div className="container mx-auto px-6">
        <div className="max-w-6xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-8 text-center">
            Addressing the "Fatal Four"
          </h2>
          
          <div className="prose prose-lg max-w-none text-gray-700 mb-12 text-center">
            <p className="text-lg">
              OSHA identifies falls, caught-in-or-between, struck-by, and electrocution as the leading causes of severe injuries and fatalities in construction. At HP Inc Consulting Services, we provide targeted training to mitigate these risks.
            </p>
          </div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
            <div className="bg-red-50 p-6 rounded-lg text-center border-2 border-red-100">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-arrow-down-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Falls</h3>
              <p className="text-gray-600 text-sm">Leading cause of construction fatalities</p>
            </div>
            
            <div className="bg-orange-50 p-6 rounded-lg text-center border-2 border-orange-100">
              <div className="w-16 h-16 bg-orange-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-scissors-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Caught-in-or-Between</h3>
              <p className="text-gray-600 text-sm">Equipment and machinery hazards</p>
            </div>
            
            <div className="bg-yellow-50 p-6 rounded-lg text-center border-2 border-yellow-100">
              <div className="w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-hammer-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Struck-by</h3>
              <p className="text-gray-600 text-sm">Flying or falling objects</p>
            </div>
            
            <div className="bg-blue-50 p-6 rounded-lg text-center border-2 border-blue-100">
              <div className="w-16 h-16 bg-blue-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-flashlight-line text-2xl text-white"></i>
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-3">Electrocution</h3>
              <p className="text-gray-600 text-sm">Electrical hazards and power lines</p>
            </div>
          </div>
          
          <div className="bg-gray-50 p-8 rounded-lg">
            <h3 className="text-2xl font-bold text-gray-900 mb-6 text-center">
              Our Training Covers Various Scenarios
            </h3>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
              <div className="text-center">
                <div className="w-12 h-12 bg-blue-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-home-line text-xl text-blue-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Roofing</h4>
                <p className="text-sm text-gray-600">Fall protection systems</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-green-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-building-2-line text-xl text-green-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Framing</h4>
                <p className="text-sm text-gray-600">Structural safety protocols</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-orange-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-road-map-line text-xl text-orange-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Trenching</h4>
                <p className="text-sm text-gray-600">Excavation safety measures</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-flashlight-line text-xl text-purple-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Utilities</h4>
                <p className="text-sm text-gray-600">Electrical safety training</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-red-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-tools-line text-xl text-red-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Electricians</h4>
                <p className="text-sm text-gray-600">Electrical hazard prevention</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-indigo-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-building-line text-xl text-indigo-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Scaffolding</h4>
                <p className="text-sm text-gray-600">Safe scaffold practices</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-teal-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-truck-line text-xl text-teal-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">MEWP Use</h4>
                <p className="text-sm text-gray-600">Mobile elevated work platforms</p>
              </div>
              
              <div className="text-center">
                <div className="w-12 h-12 bg-pink-100 rounded-lg flex items-center justify-center mx-auto mb-3">
                  <i className="ri-shovel-line text-xl text-pink-600"></i>
                </div>
                <h4 className="font-semibold text-gray-900 mb-2">Excavations</h4>
                <p className="text-sm text-gray-600">Trenching and excavation safety</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FatalFourSection;
